<template>
    <div class="rounded-xl overflow-hidden bg-white border border-solid border-slate-200 flex">
        <button
            v-for="action in actions"
            v-show="action.show"
            :disabled="action.loading || selectedThreads.size === 0"
            :key="action.label"
            @click="action.handler"
            :data-test="`${action.id}-button`"
            class="appearance-none text-slate-800 bg-transparent flex-1 gap-1 flex flex-col items-center justify-center py-3.5 px-4 border-r border-solid border-slate-200 border-l-0 border-y-0 hover:bg-slate-50 active:bg-slate-100 last:border-0 mdShortHeight:flex-row"
            :class="{
                'opacity-50 cursor-default': action.loading,
            }"
        >
            <font-awesome-icon
                widthAuto
                v-if="!action.loading"
                :icon="action.icon"
                :class="[action.color, 'text-sm h-3.5']"
            ></font-awesome-icon>
            <vx-icon-loading v-else spin class="w-3.5!"></vx-icon-loading>
            <span class="text-[10px] leading-none text-slate-500 font-semibold">
                {{ action.label }}
            </span>
        </button>
    </div>

    <message-builder-snippets v-model:visible="closeWithSnippetModal" @selected="closeWithSnippet($event)" />
    <message-hub-assign-modal
        v-model:visible="assignModal"
        :emitOnly="true"
        @submit="(assigneeId: number | string) => handleBulkAssign(assigneeId, Array.from(selectedThreads.values()))"
    />
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxIconLoading } from '@voxie/frontend-components';
import MessageBuilderSnippets from '~/components/general/message-builder/modals/MessageBuilderSnippets.vue';
import MessageHubAssignModal from '~/components/message-hub/MessageHubAssignModal.vue';
import { useMessageHub } from '~/components/message-hub/useMessageHub';
import { useMessageHubBulkActions } from '~/components/message-hub/useMessageHubBulkActions';

const { selectedThreads } = useMessageHub();

const { actions, closeWithSnippetModal, assignModal, closeWithSnippet, handleBulkAssign } = useMessageHubBulkActions();
</script>
